/**
 * Clerk shim — provides safe no-op stubs so the app renders without auth
 * when VITE_CLERK_PUBLISHABLE_KEY is not set (the public marketing build).
 */

/** The minimal user shape the app reads off Clerk's hooks. */
type ShimUser = { id?: string; publicMetadata?: { roles?: unknown } } | null;

const noopUser: { user: ShimUser; isLoaded: boolean; isSignedIn: boolean } = {
  user: null,
  isLoaded: true,
  isSignedIn: false,
};
const noopAuth = {
  getToken: async (): Promise<string | null> => null,
  isSignedIn: false,
  signOut: async (): Promise<void> => {},
};
const noopClerk = { signOut: async (): Promise<void> => {} };

export const useUser = () => noopUser;
export const useAuth = () => noopAuth;
export const useClerk = () => noopClerk;
export const SignIn = () => null;
export const SignUp = () => null;
